import { motion, useAnimate, type AnimationSequence } from 'framer-motion'
import { useEffect } from 'react'
import { useTranslate } from '../../../../hooks/language/use-translate'
import { useGlobalStore } from '../../../../store/global-store'
import type { MessageToastMiddle } from '../../../../types/lives/messages'

interface Props {
  toast: MessageToastMiddle
}

export function Toast({ toast }: Props) {
  const remove = useGlobalStore((state) => state.removeNotifyGiftSentReturn)

  const [scope, animate] = useAnimate()

  const { translate } = useTranslate()

  useEffect(() => {
    const sequence: AnimationSequence = [
      [scope.current, { opacity: 1 }, { duration: 1 }],
      [scope.current, { x: -300, opacity: 0 }, { duration: 2, delay: 1 }],
    ]

    if (toast?.id) {
      animate(sequence).then(remove)
    }
  }, [toast?.id, scope, animate, remove])

  return (
    <motion.div
      ref={scope}
      className="h-16 w-80 flex flex-row rounded-lg items-center ml-4 px-2 text-white opacity-0"
      style={{
        backgroundImage: `linear-gradient(to right, ${toast?.background}, #e153fa10, transparent)`,
      }}
    >
      <img
        src={toast?.invisibleVisitor ? '' : toast?.imgUser}
        className="w-10 h-10 bg-black rounded-full border"
      />

      <div className="ml-2 flex flex-col">
        <span className="text-sm">
          {toast?.invisibleVisitor ? translate('invisible') : toast?.username}
        </span>

        <span className="text-sm">
          {translate('gift-return-luck-won')} {toast?.returnValues}
        </span>
      </div>
      <div className="ml-2 flex flex-col">
        <img src={toast?.imgGift} className="w-12 h-12" />
      </div>
    </motion.div>
  )
}
